
import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { 
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface BarometerPopupProps {
  isVisible: boolean;
  onClose: () => void;
}

export const BarometerPopup: React.FC<BarometerPopupProps> = ({ isVisible, onClose }) => {
  // Close popup after escape key
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isVisible) {
        onClose();
      }
    };
    
    window.addEventListener('keydown', handleEsc);
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isVisible, onClose]);

  return (
    <Dialog open={isVisible} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Le Baromètre en détails</DialogTitle>
        </DialogHeader>
        <div className="text-sm text-gray-600">
          En construction et bientôt disponible ! Consultez les chiffres clés et analyses sur la citoyenneté et la laïcité en France.
        </div>
      </DialogContent>
    </Dialog>
  );
};
